import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from 'api/axiosBaseQuery'

const bookingApi = createApi({
  reducerPath: 'bookingApi',
  baseQuery: axiosBaseQuery({
    baseUrl: process.env.REACT_APP_BASE_URL ?? ''
  }),
  tagTypes: ['Booking', 'BookingList', 'PlotList'],
  endpoints: () => ({})
})

export default bookingApi
